import { jsx as _jsx } from "react/jsx-runtime";
import { component, ModalScreenView } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
import { ITipModalScreenViewModelType } from './ITipModalScreenViewModel';
import { RootScreenComponent } from '../RootScreen/RootScreenComponent';
export const TipModalScreenComponent = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.tipModal,
    dependencies: {
        viewModel: ITipModalScreenViewModelType
    }
})(({ viewModel, navigation, route }) => {
    return (_jsx(ModalScreenView, { navigation: navigation, moduleName: TipConfig.moduleName, componentName: TipConfiguration.ComponentNames.tipModal, forceCanBack: true, loading: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.loading, errorPopUp: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.error, onErrorDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.dismissError, children: _jsx(RootScreenComponent, { navigation: navigation, route: route }) }));
});
